<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <template #SHOWSTATUS>
      <order-tracker v-if="statusId" :statusId="statusId"></order-tracker>
    </template>
  </cTable>
</template>

<script>
import { getAppointmentPieces } from "@/api/analysis/appointmentPieces";
import { getCountry } from "@/api/system/country";
import { getSelectType } from "@/api/public";
import { getUser } from "@/api/user/internal";
import { getChannel } from "@/api/tracker/channel";
import { getAgent } from "@/api/tracker/agent";
import { getStatus } from "@/api/tracker/status";
import { getAllClient } from "@/api/user/client";
import orderTracker from "@/base/order_tracker";
import cTable from "@/base/common/index";
// import format from "@/utils/format";
// import expandRow from "_my/table-expand";
export default {
  name: "appointmentPieces",
  components: {
    cTable,
    orderTracker,
  },
  data() {
    return {
      statusId: "",
      methods: {
        list: getAppointmentPieces,
        getCountry,
        getAgent,
        getAllClient,
        getChannel,
        getSelectType,
      },
      config: {
        height: 630,
      },
      modals: {
        showstatus: {
          contentSlot: "SHOWSTATUS",
          methods: {
            cancel: ({ close }) => {
              this.statusId = "";
            },
          },
          footer: {
            show: false,
          },
        },
      },
      header: {
        searchs: [
          {
            key: "dateType",
            placeholder() {
              return this.$t("select") + this.$t("date") + this.$t("type");
            },
            clearable: false,
            component: "Select",
            options: [],
            config: {
              label({ row, field }) {
                return this.$t(row.label);
              },
            },
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType(["RESERVE_TIME_TYPE"])).data
                  .payload["RESERVE_TIME_TYPE"];
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              clearable: false,
              type: "date",
              options: {
                disabledDate(time) {
                  return false;
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              },
            },
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              clearable: false,
              type: "date",
              options: {
                disabledDate(time) {
                  return false;
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              },
              // "on-change"({ searchForm }) {
              //   let time = this.$page.format.timeFormat(searchForm.endTime);
              //   if (time.slice(-8) === "00:00:00") {
              //     time = time.split(" ")[0] + " " + "23:59:59";
              //     searchForm.endTime = time;
              //   }
              // }
            },
          },
          {
            key: "country",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("countryName");
            },
            clearable: true,
            options: [],
            config: { label: "code", value: "code" },
            bind: {
              style: "width:150px",
            },
          },
          {
            key: "client_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            clearable: true,
            options: [],
            config: { label: "account", value: "id" },
            bind: {
              style: "width:150px",
            },
          },
          {
            key: "customer_service_id",
            component: "Select",
            bind: {
              style: "width:150px",
            },
            placeholder() {
              return this.$t("select") + this.$t("serviceAccount");
            },
            options: [],
            config: { label: "account", value: "id" },
          },
          {
            key: "is_punctual",
            component: "Select",
            placeholder() {
              return this.$t("whether") + this.$t("timelyDelivery");
            },
            clearable: true,
            options: [
              { label: this.$t("YES"), value: "YES" },
              {
                label: this.$t("NO"),
                value: "NO",
              },
            ],
            bind: {
              style: "width:150px",
            },
          },
          {
            key: "status",
            component: "Select",
            placeholder() {
              return this.$t("whether") + this.$t("end");
            },
            clearable: true,
            options: [
              { label: this.$t("YES"), value: "YES" },
              {
                label: this.$t("NO"),
                value: "NO",
              },
            ],
            bind: {
              style: "width:150px",
            },
          },
          {
            key: "source",
            component: "Select",
            placeholder() {
              return this.$t("source") + this.$t("trajectory");
            },
            clearable: true,
            options: [],
            bind: {
              style: "width:150px",
            },
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType(["RESERVE_SOURCE"])).data
                  .payload["RESERVE_SOURCE"];
                field.options = res;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              style: "width:140px",
              type: "textarea",
              rows: 1,
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            {
              name: this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
          ],
          methods: {
            export() {
              this.exportExc();
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
        },
        {
          name: () => this.$t("order_number"),
          key: "awbno",
          align: "center",
          width: 180,
          tooltip: false,
          copy: true,
          component: "Button",
          bind: {
            type: "primary",
            size: "small",
          },
          header: {
            copy: true,
          },
          methods: {
            render: ({ value }) => {
              return value;
            },
            click({ row }) {
              // console.log("this", this);
              this.$page.$parent.statusId = row.awbno;
              this.$page
                .getModal("showstatus")
                .setTitle(row.awbno + this.$t("trajectory"));
              this.$page.getModal("showstatus").open(row.awbno);
            },
          },
        },
        {
          name: () => this.$t("Appointment"),
          key: "reserve_time",
          width: 180,
          methods: {
            render({ value }) {
              return value > 1 ? this.format.dateFormat(value * 1000) : " ";
            },
          },
        },
        {
          name: () => this.$t("deliveryTime"),
          key: "delivery_time",
          width: 180,
          methods: {
            render({ value }) {
              return value > 1 ? this.format.timeFormat(value * 1000) : " ";
            },
          },
        },
        {
          name: () => this.$t("whether") + this.$t("timelyDelivery"),
          key: "is_punctual",
          methods: {
            render({ value }) {
              return value == "YES" ? this.$t("YES") : this.$t("NO");
            },
          },
        },
        {
          name: () => this.$t("whether") + this.$t("finish"),
          key: "status",
          methods: {
            render({ value }) {
              return value == "YES" ? this.$t("YES") : this.$t("NO");
            },
          },
        },
        {
          name: () => this.$t("countryName"),
          key: "country",
        },

        {
          name: () => this.$t("clientName"),
          key: "client_name",
        },
        {
          name: () => this.$t("serviceAccount"),
          key: "service_name",
        },
        {
          name: () => this.$t("inbound_time"),
          key: "warehouse_time",
          width: 180,
          methods: {
            render({ value }) {
              return value > 1 ? this.format.timeFormat(value * 1000) : " ";
            },
          },
        },
        {
          name: () => this.$t("source") + this.$t("trajectory"),
          key: "source",
          width: 100,
        },
      ],
    };
  },
  mounted() {
    this.header.searchs.forEach(async (item) => {
      if (item.key === "client_id")
        item.options = (await getAllClient()).data.payload.rows;
      if (item.key === "country")
        item.options = (await getCountry()).data.payload.rows;
      if (item.key === "customer_service_id")
        item.options = (
          await getUser({ standard: "CustomerService" })
        ).data.payload.rows;
    });
  },
};
</script>
